module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTcwNCAxMjhhMzIgMzIgMCAwIDEgMzIgMzJ2NzA0YTMyIDMyIDAgMCAxLTMyIDMySDMyMGEzMiAzMiAwIDAgMS0zMi0zMlYxNjBhMzIgMzIgMCAwIDEgMzItMzJoMzg0eiBtMjI0IDY0YTMyIDMyIDAgMCAxIDMyIDMydjU3NmEzMiAzMiAwIDAgMS0zMiAzMmgtMTI4VjE5MmgxMjh6TTIyNCAxOTJ2NjQwSDk2YTMyIDMyIDAgMCAxLTMyLTMyVjIyNGEzMiAzMiAwIDAgMSAzMi0zMmgxMjh6IiBmaWxsPSIjMCIgcC1pZD0iMzE5NCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/View carousel-filled.svg
// module id = 9m0+
// module chunks = 75